import React from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import Body from "src/components/common/Body";
import Button from "src/components/common/Button";
import KakaoMap from "src/components/common/KakaoMap";

interface LocationState {
  address: string;
  storeName: string;
}

function MapFullView() {
  const navigate = useNavigate();
  const { userId } = useParams<{ userId: string }>();
  const location = useLocation();
  const state = location.state as LocationState;

  const address = state?.address || "";
  const storeName = state?.storeName || "매장";

  return (
    <>
      <StyledHeader>
        <Button variant="text" className="btn-back" onClick={() => navigate(-1)}>
          {storeName} 위치
        </Button>
      </StyledHeader>

      <Body type="map">
        <MapContainer>
          <KakaoMap 
            address={address} 
            callMap={true}
          />
        </MapContainer>
      </Body>
    </>
  );
}

const StyledHeader = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  height: 70px;
  padding: 0 16px;
  background: white;
  border-bottom: 1px solid ${({ theme }) => theme.color.linePrimary};
  
  .btn-back {
    font-size: 18px;
    font-weight: 600;
    color: ${({ theme }) => theme.color.primary};
  }
`;

const MapContainer = styled.div`
  width: 100%;
  height: 100vh; // 전체 화면 높이
  position: relative;
  
  > div {
    width: 100% !important;
    height: 100% !important;
  }
`;

export default MapFullView;